/* eslint-disable consistent-this */

import $ from 'jquery'
import Modeler from 'bpmn-js/lib/Modeler'
import axios from 'axios'

import { Logger, LoggerTypes } from '../../../../utils'
import { setBpmnState, setFlowGroupAttributeTab } from '../../../../actions'
import { bpmnLoadXMLDiagram, bpmnLoadXMLFile } from './BpmnUtils'
import { BpmnCustomContextPad } from './BpmnCustomContextPad'
import { BpmnPaletteProvider } from './BpmnPaletteProvider'
import { BpmnZoomControls } from './BpmnZoomControls'
import { BpmnInteractionLogger } from './BpmnInteractionLogger'
import 'mapbox-gl/dist/mapbox-gl.css'

/**
 * This debug constants allow to display all the events triggered by the BPMN modeler.
 */
const DEBUG = false

/**
 * Inherits the Modeler class with custom settings
 * @link https://github.com/bpmn-io/bpmn-js
 * @link https://www.bpmn.io
 **/
export class BpmnModeler extends Modeler {
  constructor(opt, dispatch) {
    const __init = [
      'customContextPad',
      'paletteProvider',
      'zoomControls'
      // 'propertiesPanel'
    ]

    if (DEBUG) {
      __init.push('interactionLogger')
    }

    const _additionalModules = [
      {
        __init__: __init,
        customContextPad: ['type', BpmnCustomContextPad],
        paletteProvider: ['type', BpmnPaletteProvider],
        zoomControls: ['type', BpmnZoomControls],
        interactionLogger: DEBUG ? ['type', BpmnInteractionLogger] : []
        // propertiesPanel: ['type', PropertiesPanel]
      }
    ]

    const options = {
      width: '100%',
      height: '100%',
      keyboard: {
        bindTo: window
      },
      importControls: {
        createWidget: '.io-import-export button[bpmn-action="click:bio.createNew"]',
        openWidget: '.io-import-export button[bpmn-action="click:bio.openLocal"]',
        openDialog: '#bpmn-openDialog'
      },
      exportControls: {
        bpmnWidget: '.io-import-export .io-export a[bpmn-widget="downloadBPMN"]',
        svgWidget: '.io-import-export .io-export a[bpmn-widget="downloadSVG"]'
      },
      editingControls: {
        keyboardWidget: '.io-editing-tools button[bpmn-action="click:bio.showKeyboard"]',
        keyboardDialog: '.io-dialog.keybindings-dialog[bpmn-widget="keybindings-dialog"]',
        fullscreenWidget: '.io-editing-tools button[bpmn-action="click:bio.toggleFullscreen"]'
      },
      zoomControls: {
        resetWidget: '.zoom-controls .zoom-fit',
        inWidget: '.zoom-controls .zoom-in',
        outWidget: '.zoom-controls .zoom-out'
      },
      additionalModules: _additionalModules,
      ...opt
    }
    super(options)
    this.options = options
    this.dispatch = dispatch

    this.commandStack = this.get('commandStack')

    this._initModeler()
  }

  /**
   * Initialization of modeler's methods.
   */
  _initModeler() {
    // Logger.trace(LoggerTypes.BPMN, 'BpmnModeler._initModeler()', { options: this.options, dirty: this.isDirty() })

    $('.bjs-powered-by').remove()

    // this._initImportControls()
    // this._initEditingControls()
    this._initZoomControls()
    // this._initCopyPaste()
    this._initEventHandlers()
  }

  _initEventHandlers() {
    // this.on('shape.added', (e) => {
    //   if (!this.isImportXML) {
    //     const element = e.element
    //     const isDirty = this.isDirty()
    //     Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.on(shape.added)', { element, isDirty })

    //     // -- Fire the Redux event to toggle the React views if the BPMN XML haven't been saved.
    //     // this.dispatch(setBpmnState({ isDirty: true }))
    //   }
    // })

    // this.on('shape.remove', (e) => {
    //   if (!this.isImportXML) {
    //     const element = e.element
    //     const isDirty = this.isDirty()
    //     Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.on(shape.remove)', { element, isDirty })

    //     // -- Fire the Redux event to toggle the React views if the BPMN XML haven't been saved.
    //     // this.dispatch(setBpmnState({ isDirty: true }))
    //   }
    // })

    // this.on('connection.added', (e) => {
    //   Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.on(connection.added)', {
    //     e,
    //     isImportXML: this.isImportXML,
    //     dirty: this.isDirty()
    //   })

    //   // -- Fire the Redux event to toggle the React views if the BPMN XML haven't been saved.
    //   // this.dispatch(setBpmnState({ isDirty: true }))
    // })

    // this.on('elements.cloned', (e) => {
    //   Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.on(elements.cloned)', { e })

    //   // -- Fire the Redux event to toggle the React views if the BPMN XML haven't been saved.
    //   // this.dispatch(setBpmnState({ isDirty: true }))
    // })

    this.on('element.click', (e) => {
      const element = e.element
      const elementID = element.id
      const rootID = this.get('canvas').getRootElement().id
      const centerElement = $('.commonPage_container_central.twoSections')
      const rightElement = $('.commonPage_container_lateral.right')

      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.on(element.click)', {
        e,
        element,
        elementID,
        flows: (this.get('canvas').getRootElement().children || []).filter((el) => el.id.substring(0, 5) === 'Flow_'),
        rootElement: this.get('canvas').getRootElement(),
        rootID,
        type: element.type,
        dirty: this.isDirty()
      })

      // -- list of BPMN that can be selected to display the right add-hoc menu
      if (
        [
          'bpmn:StartEvent',
          'bpmn:Task',
          'bpmn:ExclusiveGateway'
          // 'bpmn:IntermediateCatchEvent',
          // 'bpmn:EndEvent',
        ].indexOf(element.type) >= 0
      ) {
        rightElement.removeClass('close').addClass('open')
        centerElement.removeClass('close').addClass('open')

        // -- Fire the Redux event to display the correct view through React
        this.dispatch(setFlowGroupAttributeTab(elementID, element))
      } else {
        rightElement.removeClass('open').addClass('close')
        centerElement.removeClass('open').addClass('close')
      }
    })

    // this.on('commandStack.shape.move.executed', (e) => {
    //   const isDirty = this.isDirty()
    //   Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.on(commandStack.shape.move.executed)', { e, isDirty })

    //   // -- Fire the Redux event to toggle the React views if the BPMN XML haven't been saved.
    //   // this.dispatch(setBpmnState({ isDirty }))
    // })
  }

  _initImportControls() {
    const modeler = this
    const controls = this.options.importControls

    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler._initImportControls()', { controls })

    // Attach the open diagram function to the HTML widget
    const dialog = $(controls.openDialog)
    dialog.on('change', (e) => {
      let files = e.target.files

      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler._initImportControls().dialog.on(change)', { files })

      if (files.length > 0) {
        bpmnLoadXMLFile(files[0], modeler, bpmnLoadXMLDiagram)
      }
      dialog.val(null) // Clear the current filename to always fire then change event when selecting the same filename
    })

    $(controls.openWidget).on('click', (e) => {
      e.stopPropagation()
      e.preventDefault()

      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler._initImportControls().openWidget.on(click)', { e })

      dialog.trigger('click')
    })
  }

  _initEditingControls() {
    const controls = this.options.editingControls

    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler._initEditingControls()', { controls })

    $(controls.keyboardWidget).on('click', (e) => {
      e.stopPropagation()
      e.preventDefault()

      const keyboardDialog = $(controls.keyboardDialog)
      const isKeyboardVisible = keyboardDialog.is(':visible')

      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.keyboardWidget.on(click)', {
        keyboardDialog,
        isKeyboardVisible
      })

      // eslint-disable-next-line no-unused-expressions
      isKeyboardVisible ? keyboardDialog.hide() : keyboardDialog.show()
    })

    $(controls.fullscreenWidget).on('click', (e) => {
      e.stopPropagation()
      e.preventDefault()

      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.fullscreenWidget.on(click)', { e })

      if (document.fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
      } else {
        document.documentElement.requestFullscreen()
      }
    })
  }

  _initZoomControls() {
    const controls = this.options.zoomControls
    const zoomScroll = this.get('zoomScroll')

    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler._initZoomControls()', { controls, zoomScroll })

    $(controls.resetWidget).on('click', (e) => {
      e.stopPropagation()
      e.preventDefault()

      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.resetWidget.on(click)', { zoomScroll })

      zoomScroll.reset()
    })

    $(controls.inWidget).on('click', (e) => {
      e.stopPropagation()
      e.preventDefault()

      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.inWidget.on(click)', { zoomScroll })

      zoomScroll.stepZoom(1)
    })

    $(controls.outWidget).on('click', (e) => {
      e.stopPropagation()
      e.preventDefault()

      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.outWidget.on(click)', { zoomScroll })

      zoomScroll.stepZoom(-1)
    })
  }

  _initCopyPaste() {
    this.clonedElements = []
    const modeler = this

    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler._initCopyPaste()', { modeler })

    this.on('copyPaste.pasteElement', (e) => {
      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.on(copyPaste.pasteElement)', { modeler })

      modeler.clonedElements.push({
        oldID: e.descriptor.id,
        newID: e.descriptor.businessObject.id
      })
    })

    this.on('create.end', () => {
      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.on(create.end)', { modeler })

      if (modeler.clonedElements.length > 0) {
        modeler._emit('elements.cloned', {
          projectID: 'TODO',
          clonedElements: modeler.clonedElements
        })
        modeler.clonedElements = []
      }
    })
  }

  async getXML() {
    const modeler = this
    try {
      const xml = await modeler._moddle.toXML(modeler._definitions, { format: true }, (err, updatedXML) => {
        if (!err) {
          Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.getXML().onSuccess()', { updatedXML })
          return updatedXML
        }
        Logger.trace(LoggerTypes.WARN, 'BpmnModeler.getXML().onError()', { err })
        return xml
      })
      Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.getXML()', { modeler, xml, dirty: this.isDirty() })
      return xml
    } catch (err) {
      Logger.trace(LoggerTypes.WARN, 'BpmnModeler.getXML().catch()', { err })
    }
    return null
  }

  // async saveSVG() {
  //   const modeler = this
  //   try {
  //     Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.getSVG()')
  //     const svg = await modeler.saveSVG(modeler._definitions, { format: true }, (err, updatedSVG) => {
  //       if (!err) {
  //         const svgBlob = new Blob([updatedSVG], {
  //           type: 'image/svg+xml'
  //         })

  //         const downloadLink = document.createElement('a')
  //         downloadLink.download = `${Math.random(36).toString().substring(7)}.svg`
  //         downloadLink.innerHTML = 'Get BPMN SVG'
  //         downloadLink.href = window.URL.createObjectURL(svgBlob)
  //         downloadLink.onclick = (event) => {
  //           document.body.removeChild(event.target)
  //         }
  //         downloadLink.style.visibility = 'hidden'
  //         document.body.appendChild(downloadLink)
  //         downloadLink.click()
  //       }
  //     })
  //     Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.getSVG()', { modeler, svg })
  //   } catch (err) {
  //     Logger.trace(LoggerTypes.WARN, 'BpmnModeler.getSVG()', { err })
  //   }
  //   return null
  // }

  // async saveXML() {
  //   const controls = this.options.exportControls
  //   const downloadLink = $(controls.bpmnWidget)

  //   try {
  //     const xml = await this.getXML()
  //     Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.saveXML()', { xml })

  //     this._setEncoded(downloadLink, 'diagram.bpmn', xml)

  //     const downloadLink = document.createElement('a')
  //     downloadLink.download = `${Math.random(36).toString().substring(7)}.svg`
  //     downloadLink.innerHTML = 'Get BPMN SVG'
  //     downloadLink.href = window.URL.createObjectURL(svgBlob)
  //     downloadLink.onclick = (event) => {
  //       document.body.removeChild(event.target)
  //     }
  //     downloadLink.style.visibility = 'hidden'
  //     document.body.appendChild(downloadLink)
  //     downloadLink.click()
  //   } catch (err) {
  //     Logger.trace(LoggerTypes.WARN, 'BpmnModeler.saveXML()', { err })
  //     this._setEncoded(downloadLink, 'diagram.bpmn', null)
  //   }
  // }

  /**
   * If the BPMN Modeler haven't been saved this method returns `true`,
   * it returns `false` if everything is fine.
   *
   * @returns {boolean}
   */
  isDirty() {
    return this.commandStack.canUndo()
  }

  _setEncoded(link, name, data) {
    const encodedData = encodeURIComponent(data)

    if (data) {
      link.addClass('active').attr({
        href: `data:application/bpmn20-xml;charset=UTF-8,${encodedData}`,
        download: name
      })
    } else {
      link.removeClass('active')
    }
  }

  async importXMLDiagram(xml) {
    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.importXMLDiagram()', { xml })

    return bpmnLoadXMLDiagram(xml, this, false) // Do not clear the current diagram
  }

  // async importXMLDiagramFromURI(localPath) {
  //   // let restModeler = this

  //   Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.importXMLDiagramFromURI()', { localPath })

  //   return await axios.get(localPath)
  //   // .then((response) => {
  //   //   Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.importXMLDiagramFromURI().then()', { restModeler, response })
  //   //   restModeler.importXMLDiagram(response.data)
  //   // })
  //   // .catch((error) => {
  //   //   Logger.trace(LoggerTypes.WARN, 'BpmnModeler.importXMLDiagramFromURI().catch()', { error })
  //   // })

  //   // return $.getJSON(localPath, args, (response) => {
  //   //   return restModeler.importXMLDiagram(response)
  //   // })
  // }

  getElement(id) {
    const element = this.get('elementRegistry').get(id)
    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.getElement()', {
      id,
      element
    })
    return element
  }

  getViewbox() {
    const currentViewbox = this.get('canvas').viewbox()
    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.getViewbox()', { currentViewbox })
    return {
      height: currentViewbox.height,
      width: currentViewbox.width,
      scale: currentViewbox.scale,
      x: currentViewbox.x,
      y: currentViewbox.y
    }
  }

  setViewbox(height, width, scale, x, y) {
    const canvas = this.get('canvas')
    const currentViewbox = canvas.viewbox()
    let viewbox = {
      height: height || currentViewbox.height,
      width: width || currentViewbox.width,
      scale: scale || currentViewbox.scale,
      x: x || currentViewbox.x,
      y: y || currentViewbox.y
    }
    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.setViewbox()', { currentViewbox, viewbox })
    canvas.viewbox(viewbox)
  }

  selectElement(id, type) {
    const modeler = this
    const element = { element: { id: id, type: type } }
    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.selectElement()', { element, modeler })
    modeler._emit('element.click', element)
  }

  updateElementProperties(elementId, updateProperties) {
    const modeling = this.get('modeling')
    const registry = this.get('elementRegistry')
    const element = registry.get(elementId)
    Logger.trace(LoggerTypes.BPMN, 'BpmnModeler.updateElementProperties()', {
      elementId,
      updateProperties,
      element
    })

    if (element && updateProperties) {
      modeling.updateProperties(element, updateProperties)
    }
  }
}
